import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
import { CTAButton } from './ui/CTAButton';
export function CountdownSection() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown(24);
  const formatTime = (time: number) => time.toString().padStart(2, '0');
  return <section className="py-10 md:py-16 px-4 bg-white border-y-4 border-brand-orange" data-id="element-45">
      <div className="max-w-4xl mx-auto text-center" data-id="element-46">
        <h2 className="text-2xl md:text-4xl font-black text-brand-dark mb-5 md:mb-8" data-id="element-47">
          ⏰ EL PRECIO DE LANZAMIENTO TERMINA EN:
        </h2>

        <div className="flex justify-center gap-4 md:gap-8 mb-8" data-id="element-48">
          <div className="flex flex-col items-center" data-id="element-49">
            <div className="bg-brand-dark text-white text-5xl md:text-7xl font-black p-4 md:p-6 rounded-xl shadow-inner min-w-[80px] md:min-w-[120px]" data-id="element-50">
              {formatTime(hours)}
            </div>
            <span className="text-gray-500 font-bold mt-2 uppercase" data-id="element-51">hs</span>
          </div>
          <div className="text-5xl md:text-7xl font-black text-brand-dark self-start mt-2 md:mt-4" data-id="element-52">
            :
          </div>
          <div className="flex flex-col items-center" data-id="element-53">
            <div className="bg-brand-dark text-white text-5xl md:text-7xl font-black p-4 md:p-6 rounded-xl shadow-inner min-w-[80px] md:min-w-[120px]" data-id="element-54">
              {formatTime(minutes)}
            </div>
            <span className="text-gray-500 font-bold mt-2 uppercase" data-id="element-55">min</span>
          </div>
          <div className="text-5xl md:text-7xl font-black text-brand-dark self-start mt-2 md:mt-4" data-id="element-56">
            :
          </div>
          <div className="flex flex-col items-center" data-id="element-57">
            <div className="bg-brand-orange text-white text-5xl md:text-7xl font-black p-4 md:p-6 rounded-xl shadow-inner min-w-[80px] md:min-w-[120px]" data-id="element-58">
              {formatTime(seconds)}
            </div>
            <span className="text-gray-500 font-bold mt-2 uppercase" data-id="element-59">seg</span>
          </div>
        </div>

        <p className="text-xl md:text-2xl font-bold text-red-600 mb-6 md:mb-10" data-id="element-60">
          Después sube $10.000 ARS y no vuelve a bajar.
        </p>

        <div className="max-w-2xl mx-auto bg-gray-100 p-4 md:p-6 rounded-2xl mb-6 md:mb-10" data-id="element-61">
          <div className="flex justify-between text-sm font-bold text-gray-700 mb-2" data-id="element-62">
            <span data-id="element-63">🔴 Cupos al precio de lanzamiento</span>
            <span data-id="element-64">Quedan pocos</span>
          </div>
          <div className="w-full bg-gray-300 rounded-full h-4 mb-2 overflow-hidden" data-id="element-65">
            <div className="bg-red-600 h-4 rounded-full" style={{
            width: '68%'
          }} data-id="element-66"></div>
          </div>
          <div className="text-right text-sm font-bold text-red-600" data-id="element-67">
            68% de los cupos tomados
          </div>
        </div>

        <div className="max-w-xl mx-auto" data-id="element-68">
          <CTAButton text="→ ASEGURAR MI PRECIO AHORA" href="https://checkout.guiadigital360.online/cart/44131411918917:1" isLink={true} data-id="element-69" />
        </div>
      </div>
    </section>;
}